import { connect } from "react-redux";

import Main from "../Components/Main/Main";
import {
  logout,
  addConverter,
  addNConverters,
  setCreatedDefaultConverters,
  getConverters,
} from "../store/actions/actions";

const mapStateToProps = (state) => {
  return {
    converters: state.converters,
    createdDefaultConverters: state.createdDefaultConverters,
    authnoaccess: state.authnoaccess,
    locale: state.locale,
  };
};

const mapDispatchToProps = {
  logout,
  addConverter,
  addNConverters,
  setCreatedDefaultConverters,
  getConverters,
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
